/**
 * STATE
 */
let hasSeenWizard = window.localStorage.getItem('hasSeenWizard')
hasSeenWizard = hasSeenWizard ? JSON.parse(hasSeenWizard) : false

// global state object, on app startup, buckets are fetched and
// each bucket state is stored under its id key in buckets
export const state = {
  timestamp: Date.now(),
  route: { params: {}, meta: {} },
  flameProfile: null,
  areCriticalResourcesFetched: false,
  buckets: {},
  currentBucketId: null,
  maybeCurrentAppName: null,
  user: {
    username: '',
    providers: [],
  },
  serversCount: null,
  appsCount: null,
  plans: {},
  theme: 'dark',
  hasSeenWizard: hasSeenWizard,
  isPageLoading: true,
  tokens: [],
  pageTitle: null,
  otp: {},
  preferredMetrics: [],
  activatePM2: {
    isOpen: false,
    position: false,
  },
  upgradeStepper: false,
  showBackendDemoApp: true,
  showFeedbackPopup: false,
  showSupportPopup: false,
  emittedEvents: [],
  portal: {
    isOpen: false,
    initialInput: '',
  },
  navToHint: '',
  locale: null,
  isOnBoardingOpen: false,
}

// used as structure for each bucket's state ^^^
export const bucketState = {
  // Backend state
  status: null,
  user: {},
  servers: [],
  processes: [],
  alerts: {},
  anomalies: [],
  processBlacklist: [],
  metrics: {},
  serversLinked: [],
  billing: {
    cards: [],
    invoices: [],
    receipts: [],
    coupon: {},
    meta: {},
  },
  authorizedUsers: [],
  realtimeIssues: [],
  profilings: {},
  webchecks: [],
  // UI state
  ui: {
    cpuProfilingPage: {
      selectedProcesses: [],
      profiles: [],
    },
    heapProfilingPage: {
      selectedProcesses: [],
      profiles: [],
    },
    memProfilingPage: {
      selectedProcesses: [],
      snapshots: [],
    },
    selectedVariance: null,
  },
}
